import { FC, ReactElement, useMemo } from 'react'

import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import { getSwitchAutoInvestmentsModeSuccessResultSelector } from 'components/features/rewards/rewardsPane/store/selectors/orderState'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import {
  CryptoRewardsOrderSuccessResultWarning,
} from 'components/features/rewards/rewardsPane/components/CryptoRewardsOrderSuccessResultWarning/CryptoRewardsOrderSuccessResultWarning'
import { CryptoCurrencyLogo } from 'components/features/rewards/rewardsPane/containers/CryptoCurrencyLogo/CryptoCurrencyLogo'
import { getCryptoRewardsPaneProgressPercentsStateSelector } from 'components/features/rewards/rewardsPane/store/selectors/paneState'
import { FLOATING_PANE_AUTO_INVESTMENTS_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'
import {
  CryptoRewardsSuccessInvestmentImagePreset,
} from 'components/features/rewards/rewardsPane/components/CryptoRewardsSuccessInvestmentImagePreset/CryptoRewardsSuccessInvestmentImagePreset'

type CryptoRewardsAutoInvestmentSuccessStepProps = {
  onClose: () => void
}

export const CryptoRewardsAutoInvestmentSuccessStep: FC<CryptoRewardsAutoInvestmentSuccessStepProps> = ({ onClose }): ReactElement => {
  const paneProgressPercent = useStoreSelector(getCryptoRewardsPaneProgressPercentsStateSelector)

  const switchAutoInvestmentsModeResult = useStoreSelector(getSwitchAutoInvestmentsModeSuccessResultSelector)
  const currencyId = switchAutoInvestmentsModeResult?.currencyId

  const successInvestmentIcon = useMemo<ReactElement | null>(() => {
    if (!currencyId) {
      return null
    }

    const cryptoCurrencyLogo = <CryptoCurrencyLogo currencyId={ currencyId } />

    return (
      <CryptoRewardsSuccessInvestmentImagePreset>
        { cryptoCurrencyLogo }
      </CryptoRewardsSuccessInvestmentImagePreset>
    )
  }, [currencyId])

  return (
    <CryptoRewardsPanePreset
      title='Invest Your Rewards Into Crypto'
      subTitle='Success!'
      actionName='Close'
      withFooterCancel={ false }
      onSuccess={ onClose }
      progressBarPercent={ paneProgressPercent }
    >
      {switchAutoInvestmentsModeResult && (
        <CryptoRewardsOrderSuccessResultWarning
          renderMode={ FLOATING_PANE_AUTO_INVESTMENTS_MODE }
          orderSuccessResult={ switchAutoInvestmentsModeResult }
        />
      )}
      { successInvestmentIcon }
    </CryptoRewardsPanePreset>
  )
}
